import { data } from "./data";

export const dataUtils = {
  validateEmail: (email: string) =>
    data.post<{ valid: boolean }>("/api/sales/util/email", {
      email,
    }),
};
